import Head from "next/head";
import { Box, Typography, Divider, Stack } from "@mui/material";
import LandingLayout from "@/components/layout/LandingLayout";

export default function TermsPage() {
  return (
    <>
      <Head>
        <title>Пользовательское соглашение — СпортПодсчет</title>
        <meta
          name="description"
          content="Пользовательское соглашение сервиса СпортПодсчет. Условия использования, ответственность сторон, обработка данных."
        />
      </Head>

      {/* HEADER */}
      <Box
        sx={{
          py: { xs: 6, md: 8 },
          mb: { xs: 4, md: 6 },
          bgcolor: "#eaedf1",
        }}
      >
        <Box sx={{ maxWidth: 1000, mx: "auto", px: { xs: 2, md: 3 } }}>
          <Typography variant="h4" fontWeight={800} gutterBottom>
            Пользовательское соглашение
          </Typography>

          <Typography color="text.secondary">
            Настоящее соглашение определяет условия использования сервиса СпортПодсчет.
          </Typography>
        </Box>
      </Box>

      {/* CONTENT */}
      <Box sx={{ py: { xs: 6, md: 8 } }}>
        <Box sx={{ maxWidth: 1000, mx: "auto", px: { xs: 2, md: 3 } }}>
          <Stack spacing={4}>
            <Section title="1. Общие положения">
              <Typography component="p" variant="body2" color="text.secondary" sx={{ m: 0 }}>
                Настоящее Пользовательское соглашение (далее — «Соглашение») регулирует
                отношения между сервисом <b>СпортПодсчет</b> и пользователем при использовании
                программного обеспечения, сайта и связанных сервисов.
              </Typography>
            </Section>

            <Section title="2. Условия использования">
              <Box
                component="ul"
                sx={{
                  m: 0,
                  pl: 2.5,
                  color: "text.secondary",
                  "& li": { mb: 1 },
                }}
              >
                <li>Пользователь обязуется использовать сервис только в законных целях.</li>
                <li>Запрещается вмешательство в работу сервиса и попытки обхода ограничений.</li>
                <li>Один аккаунт предназначен для одного пользователя.</li>
              </Box>
            </Section>

            <Section title="3. Регистрация и доступ">
              <Typography component="p" variant="body2" color="text.secondary" sx={{ m: 0 }}>
                Для использования отдельных функций сервиса требуется регистрация. Пользователь
                несёт ответственность за сохранность своих данных доступа.
              </Typography>
            </Section>

            <Section title="4. Интеллектуальная собственность">
              <Typography component="p" variant="body2" color="text.secondary" sx={{ m: 0 }}>
                Все элементы интерфейса, программный код, дизайн и материалы сервиса являются
                интеллектуальной собственностью правообладателя СпортПодсчет.
              </Typography>
            </Section>

            <Section title="5. Ограничение ответственности">
              <Typography component="p" variant="body2" color="text.secondary" sx={{ m: 0 }}>
                Сервис предоставляется «как есть». СпортПодсчет не несёт ответственности за прямые
                или косвенные убытки, возникшие в результате использования сервиса.
              </Typography>
            </Section>

            <Section title="6. Изменение условий">
              <Typography component="p" variant="body2" color="text.secondary" sx={{ m: 0 }}>
                СпортПодсчет оставляет за собой право изменять условия настоящего соглашения без
                предварительного уведомления пользователей.
              </Typography>
            </Section>

            <Divider />

            {/* важно: не используем new Date() напрямую (разные TZ на сервере/клиенте) */}
            <Typography variant="body2" color="text.secondary">
              Последнее обновление: 05.02.2026
            </Typography>
          </Stack>
        </Box>
      </Box>
    </>
  );
}

TermsPage.getLayout = (page) => <LandingLayout>{page}</LandingLayout>;

function Section({ title, children }) {
  return (
    <Box>
      <Typography variant="h6" fontWeight={800} gutterBottom>
        {title}
      </Typography>

      {/* тут можно любые блоки (p/ul/div), без вложенных <p> в <p> */}
      <Box>{children}</Box>
    </Box>
  );
}